import { GainType } from "@/data/types";
import { sortBy } from "lodash-es";
import ArmyBookGain from "./ArmyBookGain";
import ArmyBookItem from "./ArmyBookItem";
import ArmyBookRule from "./ArmyBookRule";
import ArmyBookWeapon from "./ArmyBookWeapon";

// Grave Armor (Tough(+3)) -> Upgrade granting Rule
// Ancient Banner (Fear) -> Upgrade granting Rule
// Precision Shots -> Rule
// Combat Bike (Fast, Impact(1), Twin Rifle (30”,A4)) -> Upgrade granting Rule and Weapon
// Shred Pistol (6”, A2, Rending) -> Weapon
// Energy Sword (A2, AP(1), Rending), Energy Fist (A2, AP(3)), Fist-Pistol (12”, A3) -> [Items,Rule]

export default class ArmyBookUpgradeOption {
  type = "ArmyBookUpgradeOption";
  uid = "";
  gains = []; // should be but isnt ArmyBookWeapon|ArmyBookRule|ArmyBookItem
  label = ""; // the display or to string representation

  /**
   *
   * @param gains {[ArmyBookItem|ArmyBookRule|ArmyBookWeapon]}
   */
  constructor(gains = [], uid = "") {
    this.gains = sortBy(
      gains.map((x) => ArmyBookGain.Parse(x)),
      [
        (gain) => {
          if (gain?.type === GainType.Weapon) return 0;
          if (gain?.type === GainType.Item) return 1;
          if (gain?.type === GainType.Rule) return 2;
          return 4; // if label undefined, return last
        },
        (gain) => {
          if (gain?.type === GainType.Weapon) return -(gain as ArmyBookWeapon).range;
          if (gain?.type === GainType.Item) return gain.name;
          if (gain?.type === GainType.Rule) return gain.name;
        },
        (gain) => {
          if (gain?.type === GainType.Weapon) return gain.name;
        }
      ]
    );

    this.uid = uid;
    this.toString();
  }

  /**
   * requested sort order: Weapons by range, then items, then rules
   */
  toString() {
    const gainsStrings = this.gains.map((gain) => ArmyBookGain.Parse(gain).toString());
    const gainsLabels = [];
    gainsStrings.forEach((gain) => {
      if (gainsLabels.includes(gain)) {
        const index = gainsLabels.indexOf(gain);
        gainsLabels[index] = `2x ${gain}`;
      } else {
        gainsLabels.push(gain);
      }
    });

    return (this.label = gainsLabels.join(", "));
  }

  /**
   *
   * @param gainsString {string}
   * @returns {*[]}
   * @constructor
   */
  static ParseGains(gainsString) {
    const optionGains = gainsString.split(" and ");
    const gains = [];
    optionGains.forEach((gain) => {
      if (gain.startsWith("2x")) {
        const doubleWeapon = ArmyBookWeapon.Parse(gain.substring(3));
        gains.push(doubleWeapon, doubleWeapon);
      } else if (ArmyBookItem.Is(gain)) {
        gains.push(ArmyBookItem.FromStringSim(gain));
      } else if (ArmyBookWeapon.Is(gain)) {
        gains.push(ArmyBookWeapon.Parse(gain));
      } else if (ArmyBookRule.Is(gain)) {
        gains.push(ArmyBookRule.Parse(gain));
      } else {
        gains.push(ArmyBookItem.FromStringSim(gain));
      }
    });
    return gains;
  }

  static FromObject(option) {
    return new ArmyBookUpgradeOption(
      option.gains.map((x) => ArmyBookGain.Parse(x)),
      option.uid
    );
  }

  static ExtractGains(option) {
    let gains = [];
    if (option.gains instanceof Array) {
      option.gains.forEach((gain) => {
        if (gain instanceof Object) {
          switch (gain.type) {
            case GainType.Item:
              ArmyBookItem.FromObject(gain).content.forEach((content) => {
                gains.push(content);
              });
              break;

            case GainType.Weapon:
              gains.push(ArmyBookWeapon.FromObject(gain));
              break;

            case GainType.Rule:
              gains.push(ArmyBookRule.FromObject(gain));
              break;

            default:
              if (gain.content instanceof Array) {
                console.warn(`${gain.label} > detect item.`);
                gains.push(...ArmyBookItem.FromObject(gain).content);
              } else if (ArmyBookWeapon.Is(gain.label)) {
                console.warn(`${gain.label} > detect weapon.`);
                gains.push(ArmyBookWeapon.FromObject(gain));
              } else {
                console.warn(`${gain.label} > Unknown type(${gain.type}).`);
              }
          }
        } else {
          console.warn(`${gain} > unexpected instance.`);
        }
      });
    } else if (option.label instanceof String) {
      console.info(`try parsing UpgradeOption from string ${option.label}.`);
      console.info("ParseGains", this.ParseGains(option.label));
    } else {
      console.warn(`Unexpected instance for ${option.label}.`);
    }
    return gains;
  }
}
